import { validateGameState, type GameState } from '#lib/domain/game.state.validation.ts';
import type { GameRepository } from '../../application/game-repository.port';

const LOCAL_STORAGE_KEY = 'game-storage-v1';

export class LocalStorageGameAdapter implements GameRepository {
	public storageReady(): boolean {
		return typeof localStorage !== 'undefined';
	}

	public clear(): void {
		if (this.storageReady()) {
			localStorage.removeItem(LOCAL_STORAGE_KEY);
		}
	}

	public save(game: GameState): void {
		if (!game) {
			throw new Error('Game state is not defined');
		}

		if (this.storageReady()) {
			localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(game));
		}
	}

	public restore(): GameState | null {
		if (!this.storageReady()) return null;

		const savedGame = localStorage.getItem(LOCAL_STORAGE_KEY);
		if (!savedGame) return null;

		try {
			const parsed = JSON.parse(savedGame);
			// The Anti-Corruption Layer doing its job!
			const validated = validateGameState(parsed);

			if (!validated.success) {
				return null;
			}

			return validated.data;
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error parsing game state from localStorage:', error);
			return null;
		}
	}
}
